// extracted by mini-css-extract-plugin
module.exports = {"workflow-buttons":"workflow-buttons_workflow-buttons__3W2Og"};